export default {
  teams: [],
};
